import CastMemberCard from './CastMemberCard';

export default CastMemberCard;
